/* Asistente PASIÓN PICKLEBALL — ventana de chat.
   La conversación se guarda solo en esta pestaña (sessionStorage) para
   no perderla al cambiar de página. No se envía nada hasta que el
   cliente escribe o pulsa un tema. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-ppa]');
  if (!raiz) return;
  var I18N = {};
  try { I18N = JSON.parse((raiz.querySelector('[data-ppa-i18n]') || {}).textContent || '{}'); } catch (e) { I18N = {}; }
  function T(k, d) { return I18N[k] || d; }

  var ENDPOINT = raiz.dataset.endpoint;
  var WA = raiz.dataset.wa;
  var WA_ACTIVO = raiz.dataset.waActivo === 'true';
  var PRODUCTO = raiz.dataset.producto || '';
  var PRODUCTO_NOMBRE = raiz.dataset.productoNombre || '';
  var PLANTILLA = raiz.dataset.plantilla || '';
  var CLAVE = 'ppa-conversacion';
  var MAX_GUARDADOS = 30;

  var lanzador = raiz.querySelector('[data-ppa-abrir]');
  var panel = raiz.querySelector('.ppa-panel');
  var cerrarBtn = raiz.querySelector('[data-ppa-cerrar]');
  var lista = raiz.querySelector('[data-ppa-mensajes]');
  var temas = raiz.querySelector('[data-ppa-temas]');
  var form = raiz.querySelector('[data-ppa-form]');
  var input = raiz.querySelector('[data-ppa-input]');
  var enviarBtn = raiz.querySelector('[data-ppa-enviar]');
  var waLink = raiz.querySelector('[data-ppa-wa]');

  var URL_CARRITO = raiz.dataset.urlCarrito || '/cart';
  var URL_ANADIR = (raiz.dataset.urlAnadir || '/cart/add') + '.js';
  var MONEDA = raiz.dataset.moneda || 'EUR';
  var RAIZ_WEB = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // En Shopify los colores de STABIL y ARC están en inglés; la web los enseña así:
  var COLORES = { 'Black': 'Negro', 'Green': 'Verde', 'Orange': 'Naranja', 'Blue': 'Azul', 'Gray': 'Gris', 'Lake Blue': 'Azul claro' };

  var historial = leer();
  var ocupado = false;
  var cacheProductos = {};

  function leer() {
    try { return JSON.parse(sessionStorage.getItem(CLAVE) || '[]'); } catch (e) { return []; }
  }
  function guardar() {
    try { sessionStorage.setItem(CLAVE, JSON.stringify(historial.slice(-MAX_GUARDADOS))); } catch (e) {}
  }

  /* ---------- Texto seguro: se escapa todo y solo se permite
     negrita, listas y enlaces internos. ---------- */
  function escapar(t) {
    return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function enLinea(t) {
    return t
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\[([^\]]+)\]\((\/[^)\s]*)\)/g, function (_, texto, ruta) {
        var esProducto = ruta.indexOf('/products/') === 0;
        if (texto.charAt(0) === '/') texto = esProducto ? T('ver_producto', 'ver el producto') : ruta.indexOf('/blogs/') === 0 ? T('leer_guia', 'leer la guía') : T('ver_pagina', 'ver la página');
        return '<a href="' + ruta + '"' + (esProducto ? ' data-ppa-producto' : '') + '>' + texto + '</a>';
      })
      .replace(/\((\/(?:products|pages|blogs)\/[a-z0-9\/-]+)\)(?![^<]*<\/a>)/g, '(<a href="$1">ver</a>)')
      .replace(/(\+34 ?604 ?528 ?131)/g, WA_ACTIVO && WA ? '<a href="https://wa.me/' + WA + '" target="_blank" rel="noopener">$1</a>' : '$1');
  }
  function formatear(texto) {
    var lineas = escapar(texto).split(/\n/);
    var html = '', enLista = false, parrafo = [];
    function cerrarParrafo() { if (parrafo.length) { html += '<p>' + enLinea(parrafo.join(' ')) + '</p>'; parrafo = []; } }
    lineas.forEach(function (l) {
      var s = l.trim();
      var ficha = s.match(/^\[\[producto:([a-z0-9-]+)(?::(\d+))?\]\]$/);
      if (ficha) {
        cerrarParrafo();
        if (enLista) { html += '</ul>'; enLista = false; }
        html += '<div class="ppa-ficha" data-handle="' + ficha[1] + '" data-variante="' + (ficha[2] || '') + '"><div class="ppa-ficha__cargando">Cargando producto…</div></div>';
        return;
      }
      s = s.replace(/\[\[producto:[^\]]*\]\]/g, '');
      var item = s.match(/^[-*•]\s+(.*)$/) || s.match(/^\d+[.)]\s+(.*)$/);
      if (item) {
        cerrarParrafo();
        if (!enLista) { html += '<ul>'; enLista = true; }
        html += '<li>' + enLinea(item[1]) + '</li>';
      } else {
        if (enLista) { html += '</ul>'; enLista = false; }
        if (s === '') cerrarParrafo(); else parrafo.push(s);
      }
    });
    cerrarParrafo();
    if (enLista) html += '</ul>';
    return html;
  }

  function burbuja(rol, texto) {
    var div = document.createElement('div');
    div.className = 'ppa-msg ' + (rol === 'user' ? 'ppa-msg--yo' : 'ppa-msg--bot');
    if (rol === 'user') div.textContent = texto; else div.innerHTML = formatear(texto);
    lista.appendChild(div);
    // La tarjeta de compra va fuera de la burbuja, a todo el ancho.
    div.querySelectorAll('.ppa-ficha').forEach(function (f) {
      lista.appendChild(f);
      montarFicha(f);
    });
    if (div.innerHTML.replace(/<p>\s*<\/p>/g, '').trim() === '') div.remove();
    lista.scrollTop = lista.scrollHeight;
    return div;
  }

  /* ---------- Tarjeta de compra ---------- */
  function dinero(centimos) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: MONEDA }).format(centimos / 100); }
    catch (e) { return (centimos / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function imagen(src, ancho) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }
  function producto(handle) {
    if (!cacheProductos[handle]) {
      cacheProductos[handle] = fetch(RAIZ_WEB + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return cacheProductos[handle];
  }

  function montarFicha(el) {
    var handle = el.dataset.handle;
    var idInicial = Number(el.dataset.variante) || 0;
    producto(handle).then(function (p) {
      var inicial = p.variants.filter(function (v) { return v.id === idInicial; })[0] || null;
      var nombre = p.title.split(' — ')[0];
      var url = p.url || ('/products/' + handle);
      var selects = p.options.map(function (op, i) {
        var nombreOp = typeof op === 'string' ? op : op.name;
        var valores = typeof op === 'string' ? [] : op.values;
        if (!valores.length) valores = p.variants.map(function (v) { return v.options[i]; }).filter(function (v, k, a) { return a.indexOf(v) === k; });
        var esTalla = /talla|size/i.test(nombreOp);
        var sel = inicial ? inicial.options[i] : (esTalla && valores.length > 1 ? '' : valores[0]);
        return '<label class="ppa-ficha__op"' + (valores.length === 1 ? ' hidden' : '') + '><span>' + escapar(nombreOp) + '</span><select data-op="' + i + '">' +
          (sel === '' ? '<option value="" selected disabled>Elige</option>' : '') +
          valores.map(function (v) {
            return '<option value="' + escapar(v) + '"' + (v === sel ? ' selected' : '') + '>' + escapar(COLORES[v] || v) + '</option>';
          }).join('') + '</select></label>';
      }).join('');

      // La mochila no tiene pack de 2: lleva la etiqueta "sin-pack" en Shopify.
      var conPack = (p.tags || []).indexOf('sin-pack') === -1;
      el.innerHTML =
        '<div class="ppa-ficha__cabeza">' +
          '<img class="ppa-ficha__img" alt="" decoding="async" width="72" height="72">' +
          '<div class="ppa-ficha__datos"><a class="ppa-ficha__nombre" href="' + url + '">' + escapar(nombre) + '</a>' +
          '<span class="ppa-ficha__eleccion" data-eleccion></span>' +
          '<span class="ppa-ficha__precio" data-precio></span><span class="ppa-ficha__estado" data-estado></span></div>' +
        '</div>' +
        '<div class="ppa-ficha__ops">' + selects + '</div>' +
        '<div class="ppa-ficha__botones">' +
          '<button type="button" class="ppa-ficha__anadir" data-cant="1">' + T('anadir', 'Añadir al carrito') + '</button>' +
          (conPack ? '<button type="button" class="ppa-ficha__pack" data-cant="2">' + T('anadir_pack', 'Añadir 2 · pack') + '</button>' : '') +
        '</div>' +
        '<p class="ppa-ficha__nota" data-nota>' + (conPack ? T('nota_pack', 'El precio del pack se aplica solo en el carrito.') : '') + '</p>';

      var img = el.querySelector('.ppa-ficha__img');
      var precio = el.querySelector('[data-precio]');
      var estado = el.querySelector('[data-estado]');
      var nota = el.querySelector('[data-nota]');
      var botones = el.querySelectorAll('button[data-cant]');
      var enlaceNombre = el.querySelector('.ppa-ficha__nombre');
      var eleccion = el.querySelector('[data-eleccion]');

      function actual() {
        var vals = Array.prototype.map.call(el.querySelectorAll('select'), function (s) { return s.value; });
        if (vals.indexOf('') > -1) return null;
        return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0] || null;
      }
      function pintar() {
        var v = actual();
        var ref = v || p.variants[0];
        var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
        img.src = imagen(src, 160);
        precio.textContent = dinero(ref.price);
        // Qué ha elegido, en castellano ("Verde · talla L"). Las fotos no cambian por color.
        eleccion.textContent = Array.prototype.map.call(el.querySelectorAll('select'), function (s, i) {
          if (!s.value || s.closest('[hidden]')) return '';
          var nom = typeof p.options[i] === 'string' ? p.options[i] : p.options[i].name;
          return (/talla|size/i.test(nom) ? 'talla ' : '') + (COLORES[s.value] || s.value);
        }).filter(Boolean).join(' · ');
        enlaceNombre.href = url + (v ? '?variant=' + v.id : '');
        botones.forEach(function (b) { b.disabled = !v || !v.available; });
        estado.textContent = !v ? T('elige_talla', 'Elige talla') + (p.options.length > 1 ? T('y_color', ' y color') : '') : (v.available ? T('disponible', 'Disponible') : T('agotado', 'Agotado'));
        estado.className = 'ppa-ficha__estado' + (v && !v.available ? ' ppa-ficha__estado--no' : '');
      }
      el.addEventListener('change', pintar);
      el.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-cant]');
        if (!b || b.disabled) return;
        var v = actual();
        if (!v) return;
        var texto = b.textContent;
        botones.forEach(function (x) { x.disabled = true; });
        b.textContent = T('anadiendo', 'Añadiendo…');
        var items = [{ id: v.id, quantity: Number(b.dataset.cant) }];
        // Con carrito lateral: se añade y se abre el carrito (el chat se cierra para dejarle sitio).
        var conLateral = window.PPCarrito && window.PPCarrito.lateral();
        var peticion = conLateral
          ? window.PPCarrito.anadir(items, lanzador)
          : fetch(URL_ANADIR, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'error'); return d; }); });
        peticion
          .then(function () {
            b.textContent = T('anadido', '✓ Añadido');
            nota.innerHTML = T('listo', 'Listo.') + ' <a href="' + URL_CARRITO + '" data-ppa-ver-carrito>' + T('ver_carrito', 'Ver carrito') + '</a> · <a href="' + RAIZ_WEB + 'checkout">' + T('finalizar', 'Finalizar compra') + '</a>';
            if (conLateral) cerrar(true); else refrescarContador();
            setTimeout(function () { b.textContent = texto; pintar(); }, 2500);
          })
          .catch(function (err) {
            b.textContent = texto;
            nota.textContent = T('no_anadir', 'No se ha podido añadir') + (err && err.message && err.message !== 'error' ? ': ' + err.message : '') + T('prueba_ficha', '. Prueba desde la ficha del producto.');
            pintar();
          });
      });
      pintar();
      lista.scrollTop = lista.scrollHeight;
    }).catch(function () {
      el.innerHTML = '<a class="ppa-ficha__nombre" href="' + RAIZ_WEB + 'products/' + handle + '">' + T('ver_el_producto', 'Ver el producto') + '</a>';
    });
  }

  function refrescarContador() {
    fetch(RAIZ_WEB + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var burbujaCarrito = document.getElementById('cart-icon-bubble');
        if (!burbujaCarrito || !s['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = s['cart-icon-bubble'];
        var nuevo = tmp.querySelector('.shopify-section') || tmp;
        burbujaCarrito.innerHTML = nuevo.innerHTML;
      })
      .catch(function () {});
  }

  function saludo() {
    if (PRODUCTO_NOMBRE) {
      return T('saludo_prod_a', '¡Hola! Soy el asistente con IA de PASIÓN PICKLEBALL. ¿Tienes dudas sobre **') + PRODUCTO_NOMBRE +
        T('saludo_prod_b', '**? Pregúntame por tallas, materiales, para quién es, envíos o devoluciones.');
    }
    return T('saludo', '¡Hola! Soy el asistente con IA de PASIÓN PICKLEBALL. Te ayudo a elegir producto y talla, con envíos, devoluciones y pagos, y con cualquier duda de pickleball: reglas, técnica o cómo entrenar.');
  }

  function pintarTodo() {
    lista.innerHTML = '';
    burbuja('model', saludo());
    historial.forEach(function (m) { burbuja(m.role, m.text); });
    temas.classList.toggle('ppa-temas--inicio', historial.length === 0);
  }

  function actualizarWhatsApp(pregunta) {
    if (!waLink || !WA) return;
    var base = PRODUCTO_NOMBRE ? T('wa_duda_prod', 'Hola, tengo una duda sobre ') + PRODUCTO_NOMBRE + '.' : T('wa_duda_marca', 'Hola, tengo una duda sobre PASIÓN PICKLEBALL.');
    if (pregunta) base += ' ' + pregunta.slice(0, 200);
    waLink.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(base);
  }

  function abrir() {
    if (!lista.childElementCount) pintarTodo();
    panel.hidden = false;
    lanzador.setAttribute('aria-expanded', 'true');
    lista.scrollTop = lista.scrollHeight;
    if (window.matchMedia('(min-width: 750px)').matches) input.focus();
  }
  function cerrar(sinFoco) {
    panel.hidden = true;
    lanzador.setAttribute('aria-expanded', 'false');
    if (!sinFoco) lanzador.focus();
  }

  /* ---------- Enlace con el carrito ---------- */
  var HANDLES = ['plantillas-pickleball-stride', 'manguito-codo-pickleball-arc', 'tobillera-pickleball-stabil', 'rodillera-pickleball-flex', 'mochila-pickleball-rally', 'gominolas-creatina-pickleball-dink', 'recogepelotas-pickleball-scoop', 'funda-pala-pickleball-carry', 'pala-pickleball-led-ace'];
  function leerCarrito() {
    return fetch(RAIZ_WEB + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.items || []).filter(function (i) { return HANDLES.indexOf(i.handle) > -1; }).slice(0, 10).map(function (i) {
          return { handle: i.handle, variant: i.variant_id, quantity: i.quantity, nombre: i.product_title.split(' — ')[0], opciones: i.variant_title || '' };
        });
      })
      .catch(function () { return []; });
  }

  // Productos sin talla ni pack (mochila): si el carrito solo lleva esos, fuera las preguntas de talla y pack.
  var SIN_TALLA_NI_PACK = ['mochila-pickleball-rally', 'gominolas-creatina-pickleball-dink', 'recogepelotas-pickleball-scoop', 'funda-pala-pickleball-carry', 'pala-pickleball-led-ace'];
  function btnTema(q, b) {
    var D = {q_pack: 'Revisa mi carrito: ¿me conviene el pack de 2?', b_pack: '¿Me conviene el pack?', q_talla_ok: '¿La talla que tengo en el carrito es la correcta? Te digo mi medida.', b_talla_ok: '¿Acerté con la talla?', q_cuando: '¿Cuándo me llega si compro hoy y cuánto cuesta el envío?', b_cuando: '¿Cuándo llega?', q_devolver: '¿Y si no me va bien, puedo devolverlo?', b_devolver: '¿Y si no me va bien?', q_pagos: '¿Qué formas de pago aceptáis?', b_pagos: 'Pagos'};
    return '<button type="button" class="ppa-tema" data-q="' + T(q, D[q]) + '">' + T(b, D[b]) + '</button>';
  }

  function temasDeCarrito(items) {
    var conTalla = !items || !items.length || items.some(function (i) { return SIN_TALLA_NI_PACK.indexOf(i.handle) === -1; });
    temas.innerHTML =
      (conTalla ? btnTema('q_pack', 'b_pack') + btnTema('q_talla_ok', 'b_talla_ok') : '') +
      btnTema('q_cuando', 'b_cuando') + btnTema('q_devolver', 'b_devolver') + btnTema('q_pagos', 'b_pagos');
    temas.classList.add('ppa-temas--inicio');
  }

  document.addEventListener('click', function (e) {
    var ayuda = e.target.closest('[data-ppa-desde-carrito]');
    if (ayuda) {
      var cajon = document.querySelector('cart-drawer');
      if (cajon && cajon.close) cajon.close();
      abrir();
      leerCarrito().then(function (items) {
        var texto = items.length
          ? T('carrito_veo', 'Veo que tienes en el carrito: ') + items.map(function (i) {
              return '**' + i.quantity + ' × ' + i.nombre + '**' + (i.opciones ? ' (' + i.opciones.split(' / ').map(function (o) { return COLORES[o] || o; }).join(' · ') + ')' : '');
            }).join(', ') + (items.some(function (i) { return SIN_TALLA_NI_PACK.indexOf(i.handle) === -1; })
              ? T('carrito_ayuda_todo', '. ¿Te ayudo con la talla, el pack, el envío o la devolución?') : T('carrito_ayuda_envio', '. ¿Te ayudo con el envío o la devolución?'))
          : T('carrito_vacio', 'Tu carrito está vacío. Cuéntame cómo juegas y te recomiendo qué te conviene.');
        burbuja('model', texto);
        temasDeCarrito(items);
      });
      return;
    }
    // "Ver carrito" dentro del chat: abre el carrito lateral en vez de cambiar de página.
    var ver = e.target.closest('[data-ppa-ver-carrito]');
    var cajon2 = document.querySelector('cart-drawer');
    if (ver && cajon2 && cajon2.open) {
      e.preventDefault();
      cerrar(true);
      cajon2.open(lanzador);
    }
  });
  document.documentElement.classList.add('ppa-listo');

  function preguntar(texto) {
    texto = (texto || '').trim();
    if (!texto || ocupado) return;
    ocupado = true;
    enviarBtn.disabled = true;
    temas.classList.remove('ppa-temas--inicio');

    burbuja('user', texto);
    actualizarWhatsApp(texto);
    var previo = historial.slice(-12);
    historial.push({ role: 'user', text: texto });
    guardar();

    var puntos = document.createElement('div');
    puntos.className = 'ppa-msg ppa-msg--bot ppa-escribiendo';
    puntos.setAttribute('aria-label', 'Escribiendo');
    puntos.innerHTML = '<i></i><i></i><i></i>';
    lista.appendChild(puntos);
    lista.scrollTop = lista.scrollHeight;

    var controlador = 'AbortController' in window ? new AbortController() : null;
    var reloj = setTimeout(function () { if (controlador) controlador.abort(); }, 45000);

    leerCarrito().then(function (carrito) {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({
          message: texto, history: previo,
          page: { product: PRODUCTO, template: PLANTILLA },
          cart: carrito.map(function (i) { return { handle: i.handle, variant: i.variant, quantity: i.quantity }; })
        }),
        signal: controlador ? controlador.signal : undefined
      });
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var respuesta = (d && d.reply) ? d.reply : '';
        if (!respuesta) throw new Error('vacía');
        puntos.remove();
        burbuja('model', respuesta);
        if (d.ok) { historial.push({ role: 'model', text: respuesta }); guardar(); }
      })
      .catch(function () {
        puntos.remove();
        burbuja('model', T('error_resp', 'No he podido responder ahora mismo.') +
          (WA_ACTIVO && WA ? T('error_wa', ' Escríbenos por WhatsApp al +34 604 528 131 y te atiende una persona.') : T('error_mail', ' Escríbenos a info@pasionpickleball.com.')));
      })
      .finally(function () {
        clearTimeout(reloj);
        ocupado = false;
        enviarBtn.disabled = false;
      });
  }

  /* ---------- Eventos ---------- */
  lanzador.addEventListener('click', abrir);
  cerrarBtn.addEventListener('click', cerrar);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) cerrar(); });

  temas.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-q]');
    if (b) preguntar(b.dataset.q);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = input.value;
    input.value = '';
    input.style.height = '';
    preguntar(t);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit')); }
  });
  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 110) + 'px';
  });

  /* En móvil, el botón flotante se aparta mientras el botón de compra
     de la ficha está a la vista: nunca debe tapar "Añadir al carrito". */
  var comprar = document.querySelector('.pp-info button[name="add"], form[action*="/cart/add"] button[name="add"]');
  if (comprar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      raiz.classList.toggle('ppa--compra-visible', entradas[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(comprar);
  }

  // Altura real de la barra de compra del móvil (cambia con el área segura del iPhone).
  var barra = document.querySelector('.pp-sticky');
  if (barra && 'ResizeObserver' in window) {
    new ResizeObserver(function () {
      if (barra.offsetHeight) document.documentElement.style.setProperty('--ppa-alto-barra', barra.offsetHeight + 'px');
    }).observe(barra);
  }

  actualizarWhatsApp('');
})();
